export default __webpack_public_path__ + "static/media/kitchen4-afterE-2048w.41946d63.png";